var _path, _rect, _path2, _rect2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect3, _ellipse, _path10, _rect4, _ellipse2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _circle, _path24, _path25, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _circle2, _path26, _path27, _path28, _path29, _ellipse11, _ellipse12, _path30, _path31;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGirafaCourses(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 148,
    viewBox: "0 0 192 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.644 96.4907H171.016C174.09 96.4907 176.654 99.1026 176.654 102.414V125.953C176.654 126.615 176.365 127.318 175.817 128.048C175.272 128.774 174.521 129.455 173.732 130.051C172.949 130.642 172.159 131.125 171.563 131.461C171.265 131.628 171.019 131.758 170.848 131.844C170.763 131.888 170.697 131.92 170.653 131.942L170.635 131.951C170.603 131.962 170.556 131.978 170.494 131.999C170.366 132.042 170.174 132.107 169.924 132.189C169.422 132.354 168.684 132.591 167.744 132.875C165.865 133.443 163.179 134.202 159.962 134.961C153.52 136.481 144.986 137.992 136.548 137.992C128.11 137.992 119.719 136.481 113.421 134.962C110.275 134.204 107.661 133.445 105.835 132.877C104.922 132.593 104.207 132.357 103.721 132.192C103.478 132.11 103.293 132.046 103.169 132.002C103.107 131.98 103.061 131.964 103.03 131.953C103.03 131.953 103.03 131.953 103.03 131.953L103.007 131.942C102.963 131.92 102.897 131.888 102.812 131.844C102.642 131.758 102.395 131.628 102.098 131.461C101.501 131.125 100.712 130.642 99.9279 130.051C99.1391 129.455 98.3886 128.774 97.843 128.048C97.295 127.318 97.0063 126.615 97.0063 125.953V102.414C97.0063 99.1026 99.5698 96.4907 102.644 96.4907Z",
    fill: "#28ADE0",
    stroke: "#37383C",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 99.9263,
    y: 100.515,
    width: 6.52926,
    height: 28.5655,
    fill: "#28ADE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M190.802 129.842V94.0229",
    stroke: "#37383C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 166.851,
    y: 98.8828,
    width: 6.52926,
    height: 32.6463,
    fill: "#28ADE0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.946 95.8394H172.318C175.392 95.8394 177.956 98.4512 177.956 101.763V125.302C177.956 125.964 177.667 126.667 177.119 127.396C176.573 128.122 175.823 128.804 175.034 129.399C174.25 129.991 173.461 130.474 172.864 130.81C172.567 130.977 172.32 131.106 172.15 131.193C172.065 131.236 171.999 131.269 171.955 131.29L171.936 131.299C171.905 131.31 171.858 131.326 171.796 131.347C171.668 131.391 171.476 131.456 171.225 131.538C170.724 131.703 169.986 131.939 169.046 132.224C167.166 132.792 164.48 133.551 161.264 134.31C154.822 135.829 146.288 137.341 137.849 137.341C129.412 137.341 121.02 135.83 114.722 134.311C111.577 133.552 108.963 132.794 107.137 132.226C106.224 131.942 105.509 131.706 105.023 131.541C104.78 131.459 104.595 131.394 104.471 131.351C104.409 131.329 104.363 131.312 104.332 131.301C104.332 131.301 104.332 131.301 104.332 131.301L104.309 131.29C104.265 131.269 104.199 131.236 104.114 131.193C103.943 131.106 103.697 130.977 103.399 130.81C102.803 130.474 102.013 129.991 101.23 129.399C100.441 128.804 99.6903 128.122 99.1448 127.396C98.5968 126.667 98.3081 125.964 98.3081 125.302V101.763C98.3081 98.4512 100.872 95.8394 103.946 95.8394Z",
    stroke: "#37383C",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M153.272 126.208C153.272 126.208 149.816 126.997 145.996 127.26C142.176 127.522 137.989 127.26 137.989 127.26",
    stroke: "#37383C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M164.67 122.997L161.448 124.132",
    stroke: "#37383C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M190.717 93.7124L137.173 72.5176L83 93.7124L83.3744 94.0868L137.173 115.41L190.717 94.0868",
    fill: "#28ADE0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M190.717 93.7124L137.173 72.5176L83 93.7124L83.3744 94.0868L137.173 115.41L190.717 94.0868",
    stroke: "#37383C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M186.167 94.1041L138.379 76.3628L95.9214 93.0727L141.376 111.284L186.167 94.401",
    fill: "#28ADE0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M190.717 93.7124L137.173 72.5176L83 93.7124L83.3744 94.0868L137.173 115.41L190.717 94.0868",
    stroke: "#37383C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 52.4624,
    y: 17.189,
    width: 9.04531,
    height: 18.0906,
    fill: "#70544B"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.5325,
    cy: 10.8544,
    rx: 12.2112,
    ry: 10.8544,
    fill: "#70544B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1272 0.798234C42.319 4.01739 41.5498 17.1527 50.9798 20.3949L52.5936 20.95V28.1132V35.2767H57.3619H62.1302V28.0338V20.7911L63.4663 20.1342C76.7879 13.5836 66.5198 -3.9257 52.1272 0.798234ZM61.6534 2.66967C69.8161 6.18866 69.949 15.1701 61.8917 18.7831C53.2008 22.6801 43.256 15.4617 46.656 7.72397C48.8845 2.65281 56.0287 0.24505 61.6534 2.66967ZM60.223 27.3421V33.4631H57.3619H54.501V27.5926V21.722L57.0043 21.5554C58.3812 21.4638 59.6685 21.3511 59.8653 21.3051C60.0619 21.2589 60.223 23.9756 60.223 27.3421Z",
    fill: "#20312D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 9.04531,
    height: 18.0906,
    transform: "matrix(-1 0 0 1 97.6875 17.189)",
    fill: "#70544B"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.2112,
    cy: 10.8544,
    rx: 12.2112,
    ry: 10.8544,
    transform: "matrix(-1 0 0 1 105.828 0)",
    fill: "#70544B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.0218 0.798234C107.83 4.01739 108.599 17.1527 99.1692 20.3949L97.5553 20.95V28.1132V35.2767H92.787H88.0187V28.0338V20.7911L86.6827 20.1342C73.361 13.5836 83.6291 -3.9257 98.0218 0.798234ZM88.4955 2.66967C80.3328 6.18866 80.1999 15.1701 88.2572 18.7831C96.9482 22.6801 106.893 15.4617 103.493 7.72397C101.264 2.65281 94.1202 0.24505 88.4955 2.66967ZM89.926 27.3421V33.4631H92.787H95.6479V27.5926V21.722L93.1447 21.5554C91.7677 21.4638 90.4804 21.3511 90.2836 21.3051C90.087 21.2589 89.926 23.9756 89.926 27.3421Z",
    fill: "#20312D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8747 28.8269C51.4419 29.9248 39.5254 34.7816 35.7293 39.0753L34.9005 40.0125L21.0359 35.3352C2.20686 28.9835 3.54752 29.0599 1.6438 34.2317C-3.51219 48.2393 3.69807 59.8246 19.9467 63.6415C22.369 64.2105 24.4436 64.7458 24.5569 64.8304C24.6698 64.9151 24.913 67.7745 25.097 71.1841C25.5573 79.7117 27.3109 87.8467 31.4514 100.666C43.3148 137.398 52.8503 147.485 75.6652 147.439C95.8567 147.398 105.468 138.763 114.893 112.195C122.942 89.5088 125.335 80.3349 125.43 71.8122C125.449 70.1517 125.601 67.8866 125.769 66.7786L126.075 64.7638L129.013 64.1737C146.518 60.6572 153.902 49.8435 149.125 34.7225C147.315 28.9918 148.343 28.9557 128.753 35.4339L115.608 39.7806L113.156 37.9492C102.309 29.848 82.2168 26.3421 60.8747 28.8269Z",
    fill: "#20312D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.6101 30.3612C28.0008 33.3106 18.4629 56.9034 34.2491 102.991C45.7952 136.7 54.4257 145.614 75.4261 145.52C97.0104 145.424 105.159 135.833 118.394 94.9462C133.512 48.2397 114.754 26.1254 63.6101 30.3612ZM2.9969 35.6057C-0.896127 48.7193 4.81579 57.5654 19.6095 61.3343C25.2495 62.7708 25.1728 62.7762 25.1728 60.9592C25.1728 57.007 28.0458 48.7188 30.8817 44.4894C31.9819 42.8495 32.8043 41.4301 32.7099 41.3352C32.3618 40.9876 5.47099 32.1385 4.76103 32.1385C4.23688 32.1385 3.7313 33.1311 2.9969 35.6057ZM130.949 36.6374C115.137 41.9063 116.633 41.056 118.614 43.6504C121.782 47.8016 124.762 56.0878 124.771 60.7734C124.774 62.8099 124.865 62.8231 130.195 61.545C144.677 58.0739 151.007 48.6196 147.308 35.9866C145.942 31.323 147.026 31.2795 130.949 36.6374Z",
    fill: "#F3BD3E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M114.947 84.4086C117.351 83.8272 123.54 79.4337 122.636 82.5995C124.198 85.274 120.064 91.2319 118.647 95.1017C117.249 98.97 117.412 105.777 114.947 104.761C112.483 103.744 106.554 94.7555 106.424 90.8137C106.313 86.8705 110.9 85.3876 114.947 84.4086Z",
    fill: "#70544B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7216 51.1475C67.3707 54.477 61.603 52.1918 55.5875 46.8522C50.608 42.4323 47.0002 34.4194 49.2552 31.0226C55.0855 31.0229 68.5898 26.4484 69.1036 29.4384C69.6175 32.4285 79.6604 46.8299 72.7216 51.1475Z",
    fill: "#70544B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M123.248 54.1326C124.333 57.4423 124.698 61.5578 122.504 63.3247C120.309 65.0915 117.329 62.801 114.363 60.6111C111.397 58.4461 110.71 54.6516 111.65 51.5658C112.591 48.48 115.323 45.0357 118.434 45.2348C121.545 45.4588 122.163 50.8229 123.248 54.1326Z",
    fill: "#70544B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6288 73.0633C36.6032 76.3332 34.3729 81.9633 34.3729 81.9633C34.3729 81.9633 31.1331 87.4378 28.4697 85.2743C27.6561 81.9633 24.9343 74.0546 25.7788 71.006C26.6233 67.9574 26.8157 66.7694 29.6091 66.9661C32.4024 67.1874 34.6544 69.7934 35.6288 73.0633Z",
    fill: "#70544B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6033 29.502C91.3629 29.8515 98.162 30.5101 95.9888 34.2799C93.8155 38.0497 92.8898 48.8512 87.6045 50.8619C82.5058 52.8015 82.1483 45.4939 79.6106 41.3626C76.9823 37.0838 73.3158 32.0024 74.6414 29.5031C75.9669 27.0038 83.8195 29.1417 87.6033 29.502Z",
    fill: "#70544B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M100.724 36.1558C101.063 34.9791 100.735 33.6231 101.928 33.26C103.132 32.9001 105.289 33.4515 106.377 34.4698C114.875 38.8948 111.015 40.142 108.994 42.9643C107.103 45.6059 101.931 44.2551 100.724 43.8698C95.8799 40.7039 99.888 39.0501 100.724 36.1558Z",
    fill: "#70544B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2403 40.2675C37.4801 37.8451 40.4786 36.1492 43.0687 37.4652C45.6705 38.8051 47.864 43.1569 47.4433 46.5598C47.0021 49.9726 43.9468 52.4364 40.6058 52.6999C37.2532 52.9394 30.9674 51.463 29.8991 48.9031C28.8307 46.3432 32.9799 42.6999 35.2403 40.2675Z",
    fill: "#70544B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2887 91.9885C32.6314 90.0026 34.6265 88.7949 36.7049 90.3599C38.7951 91.9488 40.9686 96.3103 41.0928 99.448C41.2032 102.592 39.2643 104.513 36.8337 104.334C34.3915 104.13 33.4972 102.571 32.3824 100.033C31.2675 97.4961 29.9321 93.9811 31.2887 91.9885Z",
    fill: "#70544B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3165 98.541C57.0661 99.9637 50.4633 102.487 43.7448 106.784C36.3135 111.537 35.9034 112.562 38.623 119.583C53.1465 157.076 98.1553 156.617 111.781 118.836C113.994 112.701 113.636 111.522 108.394 107.678C97.1832 99.4572 80.5107 95.9209 65.3165 98.541Z",
    fill: "#20312D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2945 100.792C55.5403 102.363 37.8482 111.042 38.943 115.192C49.1966 154.056 97.2367 156.937 110.059 118.53C111.719 113.86 111.713 113.756 109.669 111.926C99.8928 103.17 83.9091 98.8691 68.2945 100.792Z",
    fill: "#FFF2C5"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.9398,
    cy: 82.7653,
    rx: 10.8544,
    ry: 12.2112,
    transform: "rotate(-10 58.9398 82.7653)",
    fill: "#20312D"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.9295,
    cy: 82.7657,
    rx: 9.04531,
    ry: 10.4021,
    transform: "rotate(-10 58.9295 82.7657)",
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.3204,
    cy: 83.0854,
    rx: 7.09035,
    ry: 7.87817,
    transform: "rotate(-10 59.3204 83.0854)",
    fill: "#70544B"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.16,
    cy: 83.1736,
    rx: 4.52265,
    ry: 5.42718,
    transform: "rotate(-10 59.16 83.1736)",
    fill: "#20312D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.6324,
    cy: 78.0382,
    r: 3.16586,
    transform: "rotate(-10 59.6324 78.0382)",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0896 64.2223C60.7411 66.706 57.3623 65.4588 54.853 65.7557C52.3437 66.0526 48.6515 68.7093 47.745 66.0825C46.8078 63.3668 51.1894 63.1764 54.3337 62.8107C57.011 62.4993 61.4641 61.5531 61.0896 64.2223Z",
    fill: "#20312D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1462 63.3175C90.4947 65.8012 93.8735 64.554 96.3828 64.8509C98.8921 65.1478 102.584 67.8045 103.491 65.1777C104.428 62.462 100.046 62.2716 96.9021 61.9059C94.2249 61.5946 89.7717 60.6483 90.1462 63.3175Z",
    fill: "#20312D"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.6423,
    cy: 82.6541,
    rx: 10.8544,
    ry: 12.2112,
    transform: "rotate(10 91.6423 82.6541)",
    fill: "#20312D"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.6343,
    cy: 82.6512,
    rx: 9.04531,
    ry: 10.4021,
    transform: "rotate(10 91.6343 82.6512)",
    fill: "white"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.8924,
    cy: 83.0859,
    rx: 7.09035,
    ry: 7.87817,
    transform: "rotate(10 91.8924 83.0859)",
    fill: "#70544B"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.7098,
    cy: 83.1135,
    rx: 4.52265,
    ry: 5.42718,
    transform: "rotate(10 91.7098 83.1135)",
    fill: "#20312D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.9083,
    cy: 78.4502,
    r: 3.16586,
    transform: "rotate(10 93.9083 78.4502)",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.19935 38.1544C3.94411 39.2976 3.1533 41.5721 3.88088 44.823C5.92548 53.9593 15.8427 55.7626 22.6081 48.2284L24.9453 45.6257L26.7093 46.2481C28.6457 46.9313 29.2903 46.7692 29.2675 45.6046C29.2429 44.339 14.5328 38.3236 9.8108 37.6482C8.30921 37.4335 7.35898 37.5667 6.19935 38.1544Z",
    fill: "#20312D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.15689 40.2275C4.28229 42.2309 6.25559 48.3343 9.37217 50.172C12.8632 52.2306 18.3554 50.8287 21.8526 46.9862C24.3682 44.2225 24.5321 44.4756 18.8118 42.2891C10.5776 39.1418 7.62327 38.6606 6.15689 40.2275Z",
    fill: "#FFF2C5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.031 38.0344C146.231 39.2806 146.916 41.5893 146.039 44.8031C143.574 53.835 133.582 55.1776 127.172 47.3384L124.957 44.6303L123.166 45.1705C121.2 45.7633 120.564 45.5716 120.64 44.4093C120.723 43.1461 135.698 37.8178 140.446 37.3616C141.957 37.2166 142.9 37.3936 144.031 38.0344Z",
    fill: "#20312D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.979 40.1069C145.759 42.1949 143.505 48.2004 140.307 49.892C136.724 51.7868 131.302 50.1323 127.986 46.1322C125.6 43.255 125.425 43.5002 131.241 41.5807C139.613 38.8178 142.586 38.4738 143.979 40.1069Z",
    fill: "#FFF2C5"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.0004,
    cy: 117.59,
    rx: 4.52265,
    ry: 5.42718,
    transform: "rotate(-10 66.0004 117.59)",
    fill: "#20312D"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.9641,
    cy: 117.387,
    rx: 4.52265,
    ry: 5.42718,
    transform: "rotate(-170 84.9641 117.387)",
    fill: "#20312D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5793 135.68C71.3288 135.68 67.2555 134.151 64.5989 131.648C64.0676 131.092 64.0676 130.119 64.776 129.702C65.4844 129.285 66.7242 129.285 67.2555 129.841C69.3807 131.787 72.3914 132.9 75.5793 132.9C78.7671 132.9 81.7778 131.787 83.726 129.841C84.2573 129.285 85.497 129.146 86.2054 129.702C86.9138 130.119 87.0909 131.092 86.3825 131.648C83.9031 134.151 79.8297 135.68 75.5793 135.68Z",
    fill: "#20312D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5315 28.4552C28.6325 32.1937 17.6831 54.919 28.9592 93.9829C40.8286 135.101 51.6277 147.542 75.4306 147.518C98.9304 147.494 108.136 136.424 121.726 91.8498C126.933 74.772 126.712 57.36 121.154 46.8043C113.559 32.3781 89.4144 25.0701 60.5315 28.4552ZM90.5422 30.9713C106.365 33.7677 117.115 41.1791 120.848 51.865C126.062 66.7896 123.615 82.7067 110.954 116.217C102.6 138.329 90.1063 147.419 70.7703 145.455C51.9068 143.539 42.016 130.593 31.2713 93.756C20.8986 58.195 28.1769 38.5374 54.1312 32.0143C62.9477 29.7986 80.9834 29.2818 90.5422 30.9713Z",
    fill: "#20312D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirafaCourses);
export default __webpack_public_path__ + "static/media/girafa-courses.0de28803a15f3dbc19df941c24283345.svg";
export { ForwardRef as ReactComponent };